<template>
  <div class="container align-items-start">
    <div id="firstStep" style="opacity: 1" class="text-start mt-3">
      <h2 style="font-size: 40px">Register Code</h2>
      <form>
        <div class="row mt-3">
          <div class="col-sm-12">
            <input
              type="text"
              @input="checkRegisterCode"
              placeholder="register code"
              v-model="registerCode"
              autocomplete="off"
              ref="registerCodeInput"
              required
            />
            <span v-if="!validationStatus" class="error-text"
              ><img src="@/assets/register/vector.svg" /> กรุณาระบุ code
              ที่ถูกต้อง
            </span>
            <div style="color: #51646b" class="fs-6 my-4">
              <div>1. Require register code to create account</div>
              <div>
                2. If you didn't have code please register on
                <a
                  class="tag-active-color cursor-pointer"
                  style="text-decoration: underline"
                  target="_bank"
                  @click="$router.push('/book-demo')"
                  >Book demo</a
                >
              </div>
            </div>
          </div>
        </div>
      </form>
      <button
        class="btn btn-start mt-3 mb-1"
        :style="{ width: '100%' }"
        @click="checkCode"
        :disabled="!valid_code"
      >
        Next
      </button>
    </div>
  </div>
</template>
<script>
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
export default {
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      registerCode: null,
      valid_code: false,
      validationStatus: true,
    };
  },
  validations() {
    return {
      registerCode: { required },
    };
  },
  methods: {
    checkCode() {
      let registerCodeList = ["KB24", "UOB27", "B3DEMO", "FTI20"];

      if (registerCodeList.indexOf(this.registerCode) == -1) {
        this.validationStatus = false;
      } else {
        this.$store.dispatch("register/setRegisterCode", this.registerCode);

        this.$router.push({
          name: "Register",
        });
      }
      // console.log('this.registerCode',this.registerCode,this.validationStatus)
    },
    checkRegisterCode() {
      if (this.registerCode) {
        this.valid_code = true;
      } else {
        this.valid_code = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  font-family: "Noto Sans", sans-serif;
  font-size: 1rem;
  color: #333;
  width: 100%;
  min-height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;

  // background: radial-gradient(#009345, #106B4E);
  #progress {
    position: absolute;
    top: 0;
    left: 0;
    width: 0%;
    height: 1vh;
    background-color: #51646b;
    transition: width 0.8s ease-in-out;
  }
}

h1 {
  position: absolute;
  width: max-content;
  font-size: 2rem;
  color: #51646b;
  opacity: 0;
  transition: 0.8s ease-in-out;

  &.show-final {
    opacity: 1;
  }
}

h2 {
  font-weight: bold;
  color: #51646b;
}

#register {
  position: relative;
  // width: 480px;
  // height: 80px;
  padding: 10px;
  // background-color: #fff;
  // box-shadow: 0 15px 30px rgba(0, 0, 0, .2),
  //   0 10px 10px rgba(0, 0, 0, .2);

  &.close {
    width: 0;
    padding: 10px 0;
    overflow: hidden;
    transition: 0.8s ease-in-out;
    box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.2);
  }
}

.errMsg {
  transition: 0.8s ease-in-out;
  font-size: 16px;
  font-weight: bold;
}

.previousButton {
  position: absolute;
  left: 30px;
  top: 12px;
  font-size: 1rem;
  color: #9e9e9e;
  cursor: pointer;
  z-index: 20;

  &:hover {
    color: #51646b;
  }
}

.forwardButton {
  position: absolute;
  top: 30px;
  right: 20px;
  font-size: 3rem;
  color: #51646b;
  cursor: pointer;
  z-index: 20;

  &:hover {
    color: #51646b;
  }
}

.wrong .forwardButton {
  color: #d93f38;
}

.close .forwardButton,
.close .previousButton {
  color: #fff;
}

#inputContainer {
  position: relative;
  padding: 30px 20px 20px 20px;
  margin-right: 60px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;

  input {
    position: relative;
    width: 100%;
    font-size: 1.35rem;
    font-weight: bold;
    outline: 0;
    background: transparent;
    box-shadow: none;
    border: none;

    &:valid + #inputLabel {
      top: 3px;
      left: 42px;
      font-size: 0.7rem;
      font-weight: normal;
      color: #999;
    }
  }
}

#firstStep {
  position: relative;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  // input:valid {
  //   border: 1px solid #ebeeef;
  // }
  input {
    position: relative;
    width: 100%;
    font-size: 0.85rem;
    font-weight: bold;
    outline: 0;
    padding: 10px;
    // background: transparent;
    box-shadow: none;
    // margin-bottom: 15px;
    // border: none;
    border: 1px solid #ebeeef;
    border-radius: 8px;
    margin-right: 15px;

    &:valid + #inputLabel {
      top: 3px;
      left: 42px;
      font-size: 0.7rem;
      font-weight: normal;
      color: #999;
    }
  }
}

#inputLabel {
  position: absolute;
  top: 32px;
  left: 20px;
  font-size: 1.35rem;
  font-weight: bold;
  pointer-events: none;
  transition: 0.2s ease-in-out;
}

.g-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  padding: 4px 8px;
  border-radius: 3px;
  background-color: #3c82f7;
  color: #fff;
  box-shadow: 0 3px 0 #0f69ff;
}

#inputProgress {
  width: 0%;
  border-bottom: 6px solid #51646b;
  transition: width 0.6s ease-in-out;
}

.wrong #inputProgress {
  border-color: #d93f38;
}

.btn-signup {
  font-size: 10px;
  padding: 5px;
  width: 100%;
  text-align: center;
  background-color: #fff;
  color: #265054;
  height: 50px;
  border-radius: 10px;
  text-transform: uppercase;
  border: 1px solid #265054;
}

.showContainer {
  opacity: 1 !important;

  #inputProgress {
    width: 100%;
  }
}

.wronganimation {
  animation: 0.5s linear 0s 1 wrong-animation;
}

.okanimation {
  animation: 0.2s linear 0s 1 ok-animation;
}

@keyframes wrong-animation {
  0% {
    transform: translateX(0);
  }

  20% {
    transform: translateX(-20px);
  }

  40% {
    transform: translateX(20px);
  }

  60% {
    transform: translateX(-20px);
  }

  80% {
    transform: translateX(20px);
  }

  100% {
    transform: translateX(0);
  }
}

@keyframes ok-animation {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(10px);
  }

  100% {
    transform: translateY(0);
  }
}

/* Password Input --------- */

.input_container {
  position: relative;
  padding: 30px;
  // box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  // border-radius: 6px;
  background: #fff;
}

.right-container {
  position: relative;
  font-family: "Noto Sans", sans-serif;
  display: block;
  //   justify-content: center;
  //   align-items: center;
  margin: auto;
  padding-left: 5%;
}

input[type="password"] {
  line-height: 1.5;
  display: block;
  color: rgba(136, 152, 170, 1);
  font-weight: 300;
  width: 100%;
  height: calc(2.75rem + 2px);
  padding: 0.625rem 0.75rem;
  border-radius: 0.25rem;
  background-color: #fff;
  transition: border-color 0.4s ease;
  border: 1px solid #cad1d7;
  outline: 0;
}

input[type="password"]:focus {
  border-color: rgba(50, 151, 211, 0.45);
}

/* Checkmark & Strikethrough --------- */
.is_valid {
  color: rgba(77, 202, 66, 0.8);
}

.is_valid:before {
  width: 100%;
}

.checkmark_container {
  border-radius: 50%;
  position: absolute;
  top: 27px;
  right: 43%;
  background: #2ecc71;
  width: 50px;
  height: 50px;
  visibility: hidden;
  opacity: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.4s ease;
}

.login-choice span {
  color: #5b6987;
  display: -ms-grid;
  display: grid;
  font-size: 16px;
  width: 100%;
  line-height: 40px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  text-align: center;
  -ms-grid-columns: minmax(20px, 1fr) auto minmax(20px, 1fr);
  grid-template-columns: minmax(20px, 1fr) auto minmax(20px, 1fr);
  grid-gap: 19px;
}

.login-choice span:after,
.login-choice span:before {
  content: "";
  border-top: 1px solid #e5e8ed;
}

.show_checkmark {
  visibility: visible;
  opacity: 1;
}

.checkmark {
  width: 100%;
  height: 100%;
  fill: none;
  stroke: white;
  stroke-width: 15;
  stroke-linecap: round;
  stroke-dasharray: 180;
  stroke-dashoffset: 180;
}

.checked {
  animation: draw 0.5s ease forwards;
}

@keyframes draw {
  to {
    stroke-dashoffset: 0;
  }
}
</style>
